class CheckKit extends HTMLElement {
    constructor() {
        super();

        this.checkInCart = this.checkInCart.bind(this);
        this.observeInput = this.observeInput.bind(this);
    }

    connectedCallback() {
        // Elements
        this.button = document.querySelectorAll('.product-form__kit');

        // Attributes
        this.variantId = this.getAttribute('data-variant-id');
        this.productId = this.getAttribute('data-product-id');

        // Events
        document.addEventListener('document:cart:updated', () => {
            this.checkInCart();
        });

        /*this.button.forEach((button) => {
            button.addEventListener('click', (e) => {
                button.disabled = true
            })
        })*/

        // Listener
        this.observeInput();

        // Function
        this.checkInCart();
    }

    checkInCart() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                console.log(cart.items)
                const inCart = cart.items.some(
                    item => String(item.product_id) === String(this.productId)
                );

                this.button.forEach((button) => {
                    button.disabled = inCart;
                });
            })
            .catch(err => {
                console.error('Cart check error:', err);
            });
    }

    observeInput() {
        this.input = document.querySelector('.product-form--product[type="hidden"][name="id"]');
        if (!this.input) return;

        let lastValue = this.input.value;

        const checkValue = () => {
            if (this.input.value !== lastValue) {
                this.button.forEach((button) => {
                    button.disabled = true
                })
                lastValue = this.input.value;
                this.variantId = lastValue;
                this.dataset.variantId = lastValue;
                this.checkInCart();
            }
            requestAnimationFrame(checkValue);
        };

        requestAnimationFrame(checkValue);
    }

}

if (customElements.get('w3-check-kit') === undefined) {
    customElements.define('w3-check-kit', CheckKit);
}
